import { VaporToolbar, VaporToolbarProps } from "../VaporToolbar";
export const Toolbar = VaporToolbar;
export interface ToolbarProps extends VaporToolbarProps {}
